import type { GQL_ID, CommonSort } from '@@partner:types:graphql'
import type { Category } from '@@partner:types:app'

import React from 'react'
import { Button, Avatar } from 'rsuite'
import { Link } from 'react-router-dom'
import ResponsiveTable, { ResponsiveTableColumn } from '@components/common/ResponsiveTable/ResponsiveTable'
import CommonStatusLabel from '@components/common/CommonStatusLabel'

import { NO_PHOTO_IMAGE } from '@@partner:config/image'
import { SORT_ORDER_DESC } from '@@partner:config/graphql'

export interface CategoriesTableProps {
  categories: Category[]
  loading: boolean
  tableSort: CommonSort
  onSortColumn?: (column: string, sortType: string) => void
  generateEditUrl?: (categoryId: GQL_ID) => string
}

export default function CategoriesTable ({
  categories = [],
  loading = true,
  tableSort,
  onSortColumn,
  generateEditUrl
}: CategoriesTableProps) {
  const columns: ResponsiveTableColumn<Category>[] = [
    {
      dataKey: 'id',
      header: 'ИД',
      sortable: true,
      flexGrow: 1,
      isCardBadge: true
    },
    {
      dataKey: 'icon',
      header: 'Изображение',
      flexGrow: 1,
      hideOnMobile: true,
      render: (category) => (
        <>
          <div>
            Desktop:
            <Avatar src={category?.icon?.url ?? NO_PHOTO_IMAGE} size="lg" />
          </div>
          <div>
            Mobile:
            <Avatar src={category?.altIcon?.url ?? NO_PHOTO_IMAGE} size="lg" />
          </div>
        </>
      )
    },
    {
      dataKey: 'name',
      header: 'Название',
      sortable: true,
      flexGrow: 2,
      isCardTitle: true
    },
    {
      dataKey: 'parent_id',
      header: 'Родительская',
      sortable: true,
      flexGrow: 2,
      render: (category) => <span>{category.parent?.name}</span>
    },
    {
      dataKey: 'status',
      header: 'Статус',
      sortable: true,
      flexGrow: 1,
      isCardBadge: true,
      render: (category) => <CommonStatusLabel status={category.status} />
    }
  ]

  const renderActions = (category: Category) => (
    <Button
      color="cyan"
      as={Link}
      to={generateEditUrl?.(category.id) || '#'}
      size="xs"
    >
      Изменить
    </Button>
  )

  return (
    <ResponsiveTable<Category>
      data={categories}
      columns={columns}
      loading={loading}
      sortColumn={tableSort.fieldName}
      sortType={tableSort.direction === SORT_ORDER_DESC ? 'desc' : 'asc'}
      onSortColumn={onSortColumn as any}
      renderActions={renderActions}
      rowKey="id"
    />
  )
}
